import * as React from 'react';
import styled from 'styled-components';
import PropTypes, { instanceOf } from 'prop-types';
import { Cookies, withCookies } from 'react-cookie';

const VimeoContainer = styled.div`
  position: relative;
  height: 100%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const Vimeo = ({ playerLink, title, width, height, allowFullScreen, className, cookies }) => {
  const consent = cookies.get('cookieConsent');
  const finalUrl = consent === 'accepted' ? playerLink : `${playerLink}?dnt=1`;
  return (
    <VimeoContainer className={className}>
      <iframe
        key={consent || 'none'}
        src={finalUrl}
        width={width}
        height={height}
        frameBorder="0"
        title={title}
        webkitallowfullscreen={allowFullScreen.toString()}
        mozallowfullscreen={allowFullScreen.toString()}
        allowFullScreen={allowFullScreen.toString()}
      />
    </VimeoContainer>
  );
};

Vimeo.defaultProps = {
  allowFullScreen: true,
  className: ''
};

Vimeo.propTypes = {
  playerLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  allowFullScreen: PropTypes.bool,
  className: PropTypes.string,
  cookies: instanceOf(Cookies).isRequired
};

export default withCookies(Vimeo);



// WEBPACK FOOTER //
// ./src/components/Vimeo/index.jsx